import { cn } from '@/lib/utils';
import { useAtomValue } from 'jotai';
import { serverNameAtom } from '@/hooks/status';
import ServerMenu from './ServerMenu';
import ServerControls from './ServerControls';
import ServerStatus from './ServerStatus';
import ServerSchedule from './ServerSchedule';


type ServerSidebarProps = {
    isSheet?: boolean;
};
export function ServerSidebar({ isSheet }: ServerSidebarProps) {
    //The banner follows the server it is actually looking at, so one build can
    //be deployed to both - a hardcoded one would shout "DEV" on the live panel.
    const serverName = useAtomValue(serverNameAtom);
    const isDevServer = /\bdev\b/i.test(serverName);

    return (
        <aside
            className={cn(
                'flex flex-col gap-4 z-10',
                isSheet ? 'px-4 py-6' : 'tx-sidebar hidden lg:flex',
            )}
        >
            <div className={cn(
                !isSheet && 'surface text-card-foreground p-4',
            )}>
                <ServerMenu />
            </div>
            <hr className={cn('border-edge', isSheet ? 'block' : 'hidden')} />
            <div className={cn(
                !isSheet && 'surface text-card-foreground p-4',
                'flex flex-col gap-4'
            )}>
                {/* <h2 className="text-lg font-semibold tracking-tight overflow-hidden text-ellipsis">
                    Controls & Status
                </h2> */}
                {isDevServer ? (
                    <div className="tx-dev-banner-block">DAS IST DER DEV SERVER</div>
                ) : null}
                <ServerControls />
                <ServerStatus />
                <ServerSchedule />
            </div>
        </aside>
    );
}
